<template>
    <div class="flex flex-col dark:text-white">
        <filters
            v-model="filters"
            @fetch="
                pagination.current_page = 1;
                users = [];
                next_page_url = false;
                fetch();
            "
            :loading="loading"
            search-filter
            search-label="Filtre por nome, e-mail, cpf ou cnpj"
            class="my-5"
        />

        <ticto-loading v-if="loading" />
        <empty-state v-else-if="users.length === 0" />
        <div
            v-else
            class="not-prose relative overflow-hidden rounded-xl border border-black/5 bg-white shadow-xs dark:border-white/10 dark:bg-white/[0.02]"
        >
            <ul
                role="list"
                class="divide-y divide-black/5 dark:divide-white/[0.06]"
            >
                <li v-for="user in users" :key="user.email">
                    <a
                        @click.prevent="manage(user)"
                        class="block transition-colors hover:cursor-pointer hover:bg-black/[0.02] dark:hover:bg-white/[0.03]"
                    >
                        <div class="flex items-center gap-4 px-4 py-3.5">
                            <div class="shrink-0">
                                <dice-bear-avatar
                                    :seed="user.name"
                                    :url="user.avatar"
                                />
                            </div>

                            <div class="min-w-0 flex-1">
                                <div class="flex flex-wrap items-center gap-2">
                                    <p
                                        class="truncate text-sm font-medium text-gray-900 dark:text-white"
                                    >
                                        {{ user.name }}
                                    </p>
                                    <span
                                        v-if="user.deleted_at"
                                        class="chip-rose"
                                    >
                                        Inativo
                                    </span>
                                    <span
                                        v-if="user.is_producer"
                                        class="chip-indigo"
                                    >
                                        Produtor
                                    </span>
                                    <span
                                        v-if="user?.setting?.is_blocked"
                                        class="chip-rose"
                                    >
                                        Bloqueado
                                    </span>
                                </div>
                                <p
                                    class="mt-0.5 flex items-center gap-1.5 text-sm text-gray-500 dark:text-gray-400"
                                >
                                    <EnvelopeIcon
                                        class="h-4 w-4 shrink-0 text-gray-400"
                                        aria-hidden="true"
                                    />
                                    <span class="truncate">{{
                                        user.email
                                    }}</span>
                                </p>
                            </div>

                            <div
                                class="hidden shrink-0 flex-col items-end gap-1 md:flex"
                            >
                                <time
                                    :datetime="user.created_at"
                                    class="text-xs tabular-nums text-gray-400 dark:text-gray-500"
                                >
                                    {{ user.created_at }}
                                </time>
                            </div>

                            <button
                                v-if="
                                    user.deleted_at &&
                                    hasPermission('delete.users')
                                "
                                @click.stop="reactivateUser(user.id)"
                                type="button"
                                class="chip-emerald hover:bg-emerald-500/20"
                            >
                                Reativar
                            </button>
                            <ChevronRightIcon
                                v-else
                                class="h-5 w-5 shrink-0 text-gray-300 dark:text-gray-600"
                                aria-hidden="true"
                            />
                        </div>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import {
    CheckCircleIcon,
    ChevronRightIcon,
    ClockIcon,
    EnvelopeIcon,
    NoSymbolIcon,
    UserCircleIcon,
} from "@heroicons/vue/24/outline";
import { mapWritableState } from "pinia";
import FormToggle from "../../components/forms/FormToggle.vue";
import Filters from "../../components/layouts/Filters.vue";
import Pagination from "../../components/layouts/Pagination.vue";
import EmptyState from "../../components/layouts/EmptyState.vue";
import TictoLoading from "../../components/layouts/TictoLoading.vue";
import { Store } from "../../stores/store";
import DiceBearAvatar from "../../components/common/DiceBearAvatar.vue";

export default {
    components: {
        DiceBearAvatar,
        EmptyState,
        FormToggle,
        TictoLoading,
        Filters,
        Pagination,
        ChevronRightIcon,
        CheckCircleIcon,
        EnvelopeIcon,
        NoSymbolIcon,
        ClockIcon,
        UserCircleIcon,
    },
    data() {
        return {
            opensearch: 1,
            pagination: {
                total: 0,
                per_page: 10,
                current_page: 1,
                last_page: 11,
                from: 1,
                to: 11,
            },
            filters: {
                text: "",
            },
            loading: false,
            users: [],
            next_page_url: false,
        };
    },
    computed: {
        ...mapWritableState(Store, ["user", "permissions"]),
    },

    mounted() {
        this.fetch();
    },

    methods: {
        fetch() {
            this.loading = true;

            const params = this.filters;
            params["page"] = this.pagination.current_page;
            params["opensearch"] = this.opensearch;

            axios
                .get("/api/user", {
                    params: params,
                })
                .then(({ data }) => {
                    this.users = data;

                    this.pagination.current_page += 1;
                    this.next_page_url = data.next_page_url;
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                });
        },
        hasPermission(name) {
            return this.permissions.find(
                (permission) => permission.name === name,
            );
        },
        async reactivateUser(id) {
            this.loading = true;

            await axios
                .put(`/api/user/${id}/reactivate`, { user_id: id })
                .then(({ data }) => {
                    this.users = [];
                    this.pagination.current_page = 0;
                    this.fetch();

                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                });
        },
        manage(user) {
            this.user = user;
            this.$router.push({
                name: "user.commissions",
                params: {
                    user_id: user.id,
                },
            });
        },
        formatCurrency(value) {
            return (value / 100).toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
            });
        },
    },
};
</script>
